import { TableColumn } from '@/components/new/table/DataTable'
import { IExpedient } from '@/containers/logistic/expedients/interfaces/interfaces'
import OrderStatusBadge from '@/components/misc/badges/OrderStatusBadge'
import { formatDateForTable } from '@/utils/helpers'
import { AlertTriangleIcon, UploadIcon } from 'lucide-react'
import { IDocumentTable } from '@/containers/logistic/expedients/wizzardExpedient/tabs/document/interfaces'
import { IProduct } from '../../../interfaces/interfaces'

export const columns: TableColumn<IProduct>[] = [
  {
    accessorKey: 'name',
    header: 'Producto',
    cell: ({ row }) => {
      return (
        <p className={'py-1 font-medium'}>{row.original.product.name || '-'}</p>
      )
    },
  },
  {
    accessorKey: 'uniqueCode',
    header: 'Lote',
    cell: ({ row }) => {
      return (
        <p className={'py-1 font-medium'}>{row.original.uniqueCode || '-'}</p>
      )
    },
  },
  {
    accessorKey: 'availableQuantity',
    header: 'Cantidad',
    cell: ({ row }) => {
      return (
        <p className={'py-1 font-medium'}>
          {row.original.availableQuantity || '-'}
        </p>
      )
    },
  },
]
